import fromPairs from 'lodash/fromPairs';
import toPairs from 'lodash/toPairs';
import sortBy from 'lodash/sortBy';

import canUseLocalStorage from '~/misc/canUseLocalStorage';

const update = (key, value) => {
  if (value) {
    window.localStorage.setItem(key, value);
    return;
  }
  window.localStorage.removeItem(key);
};

const saveList = (key, list, limit) => {
  try {
    try {
      window.localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {
      window.localStorage.setItem(key, JSON.stringify(limit(list)));
    }
  } catch (e) {
    localStorage.removeItem(key);
  }
};

const save = (key, value) => {
  try {
    if (value) {
      window.localStorage.setItem(key, value);
    } else {
      window.localStorage.removeItem(key);
    }
  } catch (e) {
    window.localStorage.removeItem(key);
  }
};


const saveBids = ({index}) => {
  const list = sortBy(toPairs(index).filter(item => item[1].value), '1.counter')
    .map(pair => [pair[0], [pair[1].value, pair[1].counter]]);

  save('madeBids', JSON.stringify(fromPairs(list.slice(-130))));
};

const saveIntroduction = (introduction) => {
  save('introduction', JSON.stringify(introduction));
};

export default (store) => {
  if (!canUseLocalStorage) {
    return;
  }
  
  const state = store.getState();

  saveList('recentSearches', state.recentSearches.items, (list) => list.slice(0, 10));

  const viewed = sortBy(toPairs(state.loads.viewed), '1');
  saveList('viewedResults', fromPairs(viewed.slice(-200)), () => fromPairs(viewed.slice(-100)));
  saveBids(state.bids);
  saveIntroduction(state.introduction);
  
  update('installationId', state.installation.id);
  update('installationIsAssigned', state.installation.isAssigned);
  update('jobTitleReported', JSON.stringify(state.user.jobTitleReported));
  update('jobName', state.user.jobName);
  update('jobNameDesc', state.user.jobNameDesc);
};



// WEBPACK FOOTER //
// ./src/shutdown.js